import { call, put } from 'redux-saga/effects';

import { postMessageRequest } from '@api/messages';
import { toastError, toastSuccess } from '@store/notifications';

import { handleGetMessageThreads } from '../handleGetMessageThreadsSaga';

export const handleCreateMessageRequest = function* ({ payload = {} }) {
  try {
    yield call(postMessageRequest, payload.data);

    const isReply = !!payload.data.message_thread;

    if (isReply) {
      yield call(handleGetMessageThreads, {
        payload: {
          messageThread: payload.data.message_thread,
        },
      });
    }

    yield call(payload.onSuccess);

    if (!isReply) {
      yield put(
        toastSuccess({
          message: {
            defaultMessage: 'Message sent successfully',
            id: 'pages.messages.send.success',
          },
        })
      );
    }
  } catch (errors) {
    const { fieldErrors, nonFieldErrors, hasNonFieldError, hasFieldError } = errors.data || {};

    if (hasFieldError) {
      yield call(payload.setErrors, fieldErrors);
    }

    if (hasNonFieldError || !hasFieldError) {
      yield put(
        toastError({
          message: hasNonFieldError
            ? nonFieldErrors
            : {
                defaultMessage: 'An unexpected error occurred, please try again.',
                id: 'global.notification.api-error-default',
              },
        })
      );
    }

    yield call(payload.setSubmitting, false);
  }
};
